import * as R from 'ramda';

export const mapObjectKeys = R.curry((fn, obj) =>
    R.fromPairs(R.map(R.adjust(0, fn), R.toPairs(obj))));

export const mapIndexed = R.addIndex(R.map);
